import { render, staticRenderFns } from "./newOccurrence.vue?vue&type=template&id=72c85930&scoped=true&"
import script from "./newOccurrence.vue?vue&type=script&lang=js&"
export * from "./newOccurrence.vue?vue&type=script&lang=js&"
import style0 from "./occurrence.css?vue&type=style&index=0&id=72c85930&prod&scoped=true&lang=css&"
import style1 from "./newOccurrence.vue?vue&type=style&index=1&id=72c85930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c85930",
  null
  
)

export default component.exports